import type { SwitchProps } from "@mui/base/Switch";
import React from "react";

import { SwitchStyled, SwitchWrapper } from "./styles";

export type Props = SwitchProps & {
  label?: string;
};

export const Switch: React.FunctionComponent<Props> = ({ label, ...props }) =>
  label ? (
    <SwitchWrapper>
      <SwitchStyled {...props} />
      {label}
    </SwitchWrapper>
  ) : (
    <SwitchStyled {...props} />
  );

Switch.displayName = "Switch";
